import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";

export interface UploadResult {
  url: string;
}

/** Yuklashlar API — backend'dagi `UploadsController` ko'zgusi (`/api/v1/uploads`). */
export class UploadsApi extends BaseApi {
  private readonly baseUrl: string = "/uploads";

  /** Rasm yuklaydi va uning doimiy ommaviy manzilini qaytaradi. */
  uploadImage(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return this.request.post<UploadResult, ApiResponse<UploadResult>>(
      `${this.baseUrl}/image`,
      formData,
    );
  }

  /** Promo/intro videoni yuklaydi va doimiy ommaviy manzilini qaytaradi. */
  uploadVideo(file: File, onProgress?: (p: number) => void) {
    const formData = new FormData();
    formData.append("file", file);
    return this.request.post<UploadResult, ApiResponse<UploadResult>>(
      `${this.baseUrl}/video`,
      formData,
      {
        onUploadProgress: event => {
          if (onProgress && event.total) {
            onProgress(Math.round((event.loaded * 100) / event.total));
          }
        },
      },
    );
  }
}

export const uploadsApi = new UploadsApi();
